import * as React from 'react';
import Component from '../../../Component';

export default class THead extends Component {

    render() {
        const ths = this.props.days.arr.map((day: any) => {
            const style: any = {};
            if (day.endOfMonth) {
                style.borderRightColor = '#dee2e6';
                style.borderRightWidth = '3px';

            }
            style.background = '#FFFFFF';
            return <th
                key={'CalendarTHead-' + day.ISO8601}
                className={'text-center border-bottom-0 sticky-top' + (day.today ? '' : ' font-weight-normal')}
                style={style}
            >
                {day.dayOfWeek + ' '}
                {day.text}
            </th>
        });
        return <thead>
            <tr>
                <th className="border-0 shadow sticky-top"
                    style={{ borderRight: '1px solid #DEE2E6', maxWidth: '150px', left: 0, background: '#FFFFFF' }}>
                    {this.props.days.month}
                </th>
                {ths}
            </tr>
        </thead>
    }
}